import { Package } from 'lucide-react'
import { cn } from '@/lib/utils'

interface EmptyStateProps {
  title?: string
  description?: string
  icon?: React.ReactNode
  action?: React.ReactNode
  className?: string
}

export function EmptyState({
  title = 'No items yet',
  description = 'Get started by creating your first item.',
  icon,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn('pt-surface flex flex-col items-center justify-center rounded-xl px-6 py-16 text-center', className)}>
      <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
        {icon || <Package className="h-6 w-6" />}
      </div>
      <h3 className="text-base font-semibold tracking-[-0.015em]">{title}</h3>
      <p className="mt-2 max-w-sm text-sm leading-6 text-muted-foreground">{description}</p>
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
